import {isProbablyBGImage} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import BORDER_SCHEMA from './border.palette-schema.yaml';

registerTileSchema(BORDER_SCHEMA);

export function generateBorder(TILE) {
    const result = {};
    if (TILE.BORDER_RADIUS >= 0) {
        result.borderRadius = TILE.BORDER_RADIUS;
    }

    if (TILE.BORDER_COLOR && TILE.BORDER_COLOR !== 'transparent' && TILE.BORDER_COLOR !== 'none') {
        result.borderStyle = 'solid';
        result.borderWidth = TILE.BORDER_WIDTH || 1;

        if (isProbablyBGImage(TILE.BORDER_COLOR)) {
            result.borderImage = TILE.BORDER_COLOR;
        } else {
            result.borderColor = TILE.BORDER_COLOR;
        }
    }

    if (TILE.BORDER_SHOW_SHADOW) {
        result.boxShadow = TILE.BORDER_SHADOW;
    }

    return result;
}
